import { z } from 'zod';
const uuid = z.uuid(),
  hash = z.string().regex(/^[a-f0-9]{64}$/),
  text = z.string().max(4000),
  decimal = z.string().regex(/^\d+(\.\d+)?$/);
const reference = z
  .object({
    id: uuid,
    kind: z.enum(['sample', 'packaging', 'artwork', 'quote', 'po']),
    version: z.int().positive(),
    hash,
    skuId: uuid.nullable(),
  })
  .strict();
export const oemCustomerSnapshotSchema = z
  .object({
    formatVersion: z.literal('oem-customer-export-v2'),
    project: z.object({ id: uuid, label: text, brand: text.nullable() }).strict(),
    sourceTargetId: uuid,
    proposal: z.object({ id: uuid, version: z.int().positive(), hash }).strict(),
    quote: z
      .object({
        id: uuid,
        version: z.int().positive(),
        hash,
        currency: text,
        lines: z.array(
          z
            .object({
              skuId: uuid,
              targetId: uuid,
              quantity: decimal,
              unitPrice: decimal,
              currency: text,
              tax: decimal,
              specId: uuid,
            })
            .strict(),
        ),
        terms: text,
        validUntil: text,
        destination: text,
        tax: decimal,
      })
      .strict(),
    references: z.array(reference),
    sections: z.array(z.object({ heading: text, body: text, factIds: z.array(uuid) }).strict()),
    facts: z.array(
      z.object({ id: uuid, version: z.int().positive(), hash, label: text, value: text }).strict(),
    ),
    disclaimer: z.literal('DEMO — NOT FOR REGULATORY USE — ไม่ใช่ข้อมูลสำหรับใช้ยื่นจริง'),
  })
  .strict();
export type OemCustomerSnapshot = z.infer<typeof oemCustomerSnapshotSchema>;
export function checkedCustomerSnapshot(value: unknown): OemCustomerSnapshot {
  const parsed = oemCustomerSnapshotSchema.parse(value);
  if (parsed.sections.some((s) => s.factIds.some((id) => !parsed.facts.some((f) => f.id === id))))
    throw new Error('unresolved_fact');
  return parsed;
}
function escape(s: string) {
  return s.replace(
    /[&<>"']/g,
    (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c] ?? c,
  );
}
export function oemCustomerHtml(value: unknown): string {
  const s = checkedCustomerSnapshot(value);
  return `<!doctype html><html lang="th"><meta charset="utf-8"><title>${escape(s.project.label)}</title><body><h1>${escape(s.project.label)}</h1><p>${escape(s.disclaimer)}</p>${s.sections.map((section) => `<section><h2>${escape(section.heading)}</h2><p>${escape(section.body)}</p>${section.factIds.map((id) => `<p>${escape(s.facts.find((f) => f.id === id)?.value ?? '')}</p>`).join('')}</section>`).join('')}<h2>ใบเสนอราคา v${s.quote.version}</h2><p>${escape(s.quote.terms)}</p><p>Exact quote: ${escape(s.quote.id)} / ${escape(s.quote.hash)}</p><p>Source target: ${escape(s.sourceTargetId)}</p></body></html>`;
}
